<template lang="pug">
#HistoryDetail
  .container-list
    b-card(border-variant="light")
      strong Ingresar Búsqueda
      b-row
        b-col(cols="12")
          b-input-group.mt-2
            .mr-2
              label Fecha inicio
              b-form-datepicker.mb-2(size='sm' locale='es', v-model="dateStart", placeholder="Fecha inicio", style="width: 300px;")
            .mr-2
              label Fecha fin
              b-form-datepicker.mb-2(size='sm' locale='es', v-model="dateEnd", placeholder="Fecha fin", style="width: 300px;")
            .mr-2
              label Tipo de movimiento
              b-form-select.mb-3(size='sm', v-model='selectedType' :options='optionsType' value-field='item' text-field='name' disabled-field='notEnabled')
            .search-btn.mr-2
              b-button(@click="handleSearch") Buscar
    b-table(
      :items="parts",
      :fields="fields",
      head-row-variant="light-primary",
      thead-class="text-black tabla-thead",
      tbody-class="tabla-tbody",
      tbody-tr-class="bg-white",
      responsive,
      :busy="loading",
      show-empty,
      empty-text="Sin datos en historial"
    )
      template(#cell(created_at)='value')
        div {{value.item.created_at | moment('DD-MM-YYYY HH:mm')}} Hrs.
      template(#cell(actions)='value')
        div(style="font-weight: bold; color:#253590")
          b-button.btn-detail(@click="getMovementsDetails(value.item.id)") Ver Detalle
    b-modal#modal-center(centered, title='Detalle de movimiento manual', v-model="showModal", ok-only, ok-title="Cerrar", size="lg")
      b-button.export-btn.d-flex.mb-4(@click="getManualMovementDetail(movementDetail.id)", v-if="movementDetail") Exportar detalle a Excel
      .d-flex.mb-4(v-if="movementDetail")
        b-col(cols="6")
          div
            strong Fecha:
            div {{ movementDetail.created_at | moment('DD-MM-YYYY HH:mm')}} Hrs.
          div
            strong Usuario:
            div {{ movementDetail.user }}
        b-col(cols="6")
          div
            strong Tipo:
            div {{ movementDetail.tipo }}
          div
            strong Cantidad total:
            div {{ movementDetail.cantidad_total }}
      b-table(
        :items="movementDetail ? movementDetail.movimientos_inventario : []",
        :fields="fieldsDetail",
        head-row-variant="light-primary",
        thead-class="text-black tabla-thead",
        tbody-class="tabla-tbody",
        tbody-tr-class="bg-white",
        responsive,
        :busy="loadingDetail",
        show-empty,
        empty-text="Sin datos de piezas"
      )
  .d-flex.flex-row-reverse
    b-pagination(
      v-model="currentPage",
      :total-rows="count",
      prev-text="Ant.",
      next-text="Sig.",
      @change="handlePageChange"
    )
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'ManualMovementList',
  data() {
    return {
      parts: [],
      currentPage: 1,
      dateStart: null,
      dateEnd: null,
      selectedType: null,
      movementDetail: null,
      showModal: false,
      optionsType: [
        { item: null, name: 'Todos' },
        { item: 1, name: 'Ingreso' },
        // { item: 2, name: 'Entrega' },
        // { item: 3, name: 'Drop' },
        // { item: 4, name: 'Part fail' },
        { item: 5, name: 'Rebaja Drop' },
        { item: 6, name: 'RTV' },
        { item: 7, name: 'SCRAP' },
        // { item: 8, name: 'BAD' },
        { item: 9, name: 'SLOW' },
      ],
      count: 0,
      search: '',
      loading: false,
      loadingDetail: false,
      fields: [
        { key: 'created_at', label: 'Fecha del Movimiento', sortable: true },
        { key: 'tipo', label: 'Tipo de Movimiento', sortable: true },
        { key: 'partes', label: 'Partes distintas', sortable: true },
        { key: 'cantidad_total', label: 'Cantidad', sortable: true },
        { key: 'user', label: 'Usuario' },
        { key: 'actions', label: 'Acciones' },
      ],
      fieldsDetail: [
        { key: 'parte.part_number', label: 'Parte', sortable: true },
        { key: 'cantidad', label: 'Cantidad', sortable: true },
        { key: 'parte.real_location', label: 'Ubicación real', sortable: true },
        { key: 'parte.description', label: 'Descripción', sortable: true },
      ],
    }
  },
  methods: {
    ...mapActions('Warehouse', [
      'getMovementsGroups',
      'getMovementGroupDetail',
      'manualMovementDetail',
    ]),
    getManualMovementDetail(pk) {
      this.manualMovementDetail(pk)
    },
    async fetchData(page = 1) {
      this.loading = true
      let filters = `?page=${page}`

      if (this.dateStart && this.dateEnd)
        filters += `&date_start=${this.dateStart}&date_end=${this.dateEnd}`

      if (this.selectedType) filters += `&type=${this.selectedType}`

      const resp = await this.getMovementsGroups({ filters })
      if (resp.status === 200) {
        this.parts = resp.data.results
        this.count = resp.data.count
      }
      this.loading = false
    },
    async getMovementsDetails(pk) {
      this.loadingDetail = true
      const response = await this.getMovementGroupDetail({ pk })
      this.movementDetail = response.data
      this.showModal = true
      this.loadingDetail = false
    },
    handlePageChange(page) {
      this.fetchData(page)
    },
    handleSearch() {
      this.fetchData(this.currentPage)
    },
    handleClear() {
      this.search = ''
      this.fetchData(this.currentPage)
    },
  },
  created() {
    this.fetchData()
  },
}
</script>
<style lang="scss">
@import '@/style/colors.scss';

// Iconos de ordenamiento en gris ($samtek-grey)
$sort-svg: "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'>";
$sort-up: "<path fill='%23525252' d='M50 8l38 44H12z'/>";
$sort-up-soft: "<path fill='%23525252' opacity='.5' d='M50 8l38 44H12z'/>";
$sort-down: "<path fill='%23525252' d='M50 92L12 48h76z'/>";
$sort-down-soft: "<path fill='%23525252' opacity='.5' d='M50 92L12 48h76z'/>";
$sort-end: "</svg>";

$sort-icon: url("#{$sort-svg}#{$sort-up-soft}#{$sort-down-soft}#{$sort-end}");
$sort-icon-asc: url("#{$sort-svg}#{$sort-up}#{$sort-down-soft}#{$sort-end}");
$sort-icon-desc: url("#{$sort-svg}#{$sort-up-soft}#{$sort-down}#{$sort-end}");

#HistoryDetail {
  .container-list {
    box-shadow: 0px 3px 6px #00000029;
  }

  .search-btn {
    display: flex;
    align-items: center;
    margin-top: 8px;

    .btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 45px;
      padding: 0 20px;
      font-weight: 600;
      color: $samtek-black;
      background-color: $samtek-yellow;
      border: 1px solid $samtek-yellow;
      border-radius: 8px;

      &:hover,
      &:focus,
      &:active {
        color: $samtek-black;
        background-color: $samtek-yellow;
        border-color: $samtek-yellow;
        box-shadow: none;
      }
    }
  }

  // Filtros de fecha
  .b-form-datepicker {
    width: 300px;
    max-width: 100%;
    height: 45px;

    .form-control {
      height: 45px;
      font-size: 15px;
      color: $samtek-black;
      background-color: #fff;
      border: 1px solid $samtek-grey;
      border-radius: 8px;

      &:focus {
        border-color: $samtek-grey;
        box-shadow: none;
      }

      &::placeholder {
        color: $samtek-grey;
        font-size: 15px;
      }
    }

    .btn {
      height: 45px;
      color: $samtek-grey;
      background-color: #fff;
      border: 1px solid $samtek-grey;
      border-left: none;
      border-radius: 0 8px 8px 0;

      &:hover,
      &:focus {
        color: $samtek-grey;
        background-color: $center-bg;
        border-color: $samtek-grey;
        box-shadow: none;
      }
    }
  }

  // Botón "Ver Detalle" de cada fila
  .btn-detail {
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 600;
    color: $samtek-yellow !important;
    background-color: $samtek-black !important;
    border: none;
    border-radius: 20px;

    &:hover,
    &:focus,
    &:active {
      color: $samtek-black !important;
      background-color: $samtek-yellow !important;
      box-shadow: none;
    }
  }

  // Tabla
  .b-table {
    margin-bottom: 0;

    thead th {
      height: 50px;
      padding: 0 40px;
      font-size: 16px;
      font-weight: 700;
      color: $samtek-grey !important;
      background-color: $table-head-bg;
      border: none;
      vertical-align: middle;
    }

    thead th[aria-sort] {
      background-size: 16px 16px;
      background-position: right 16px center;
    }

    thead th[aria-sort='none'] {
      background-image: $sort-icon;
    }

    thead th[aria-sort='ascending'] {
      background-image: $sort-icon-asc;
    }

    thead th[aria-sort='descending'] {
      background-image: $sort-icon-desc;
    }

    tbody tr {
      height: 50px;
      background-color: #fff;
    }

    tbody td {
      height: 50px;
      padding: 0 40px;
      font-size: 15px;
      color: $samtek-black;
      background-color: #fff;
      border: none;
      vertical-align: middle;
    }

    tbody td:first-child {
      font-weight: 700;
    }
  }

  // Paginación
  .page-link {
    color: $samtek-grey;
    background-color: #fff;
    border: 1px solid $table-head-bg;

    &:hover {
      color: $samtek-grey;
      background-color: $center-bg;
      border-color: $table-head-bg;
      box-shadow: none;
    }
  }

  .page-item.active .page-link {
    color: $samtek-black;
    background-color: $samtek-yellow;
    border-color: $samtek-grey;
  }

  .page-item.disabled .page-link {
    color: $samtek-grey;
    background-color: #fff;
    border: 1px solid $table-head-bg;
  }
}

// Modal (renderizado fuera del árbol del componente: se acota por su id único)
#modal-center {
  .modal-content {
    padding: 20px;
    background-color: #fff;
    border: none;
    border-radius: 8px;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  }

  .modal-header {
    padding: 0 0 20px 0;
    background-color: #fff;
    border-bottom: none;
  }

  .modal-title {
    font-size: 18px;
    font-weight: 700;
    color: $samtek-black;
  }

  .close {
    color: $samtek-grey;
    opacity: 1;

    &:hover,
    &:focus {
      color: $danger-strong;
      opacity: 1;
    }
  }

  .modal-footer {
    padding: 20px 0 0 0;
    background-color: #fff;
    border-top: 1px solid $table-head-bg;

    .btn {
      height: 45px;
      padding: 0 24px;
      font-weight: 600;
      color: $samtek-black;
      background-color: $samtek-yellow;
      border: none;
      border-radius: 8px;

      &:hover,
      &:focus {
        color: $samtek-black;
        background-color: $samtek-yellow;
        box-shadow: none;
      }
    }
  }

  .export-btn {
    height: 45px;
    padding: 0 20px;
    font-weight: 600;
    color: $samtek-black;
    background-color: #fff;
    border: 1px solid $table-head-bg;
    border-radius: 8px;

    &:hover,
    &:focus {
      color: $samtek-black;
      background-color: $center-bg;
      border-color: $table-head-bg;
      box-shadow: none;
    }
  }

  // Tabla interna del modal
  .b-table {
    margin-bottom: 0;

    thead th {
      height: 50px;
      padding: 0 40px;
      font-size: 16px;
      font-weight: 700;
      color: $samtek-grey !important;
      background-color: $table-head-bg;
      border: none;
      vertical-align: middle;
    }

    thead th[aria-sort] {
      background-size: 16px 16px;
      background-position: right 16px center;
    }

    thead th[aria-sort='none'] {
      background-image: $sort-icon;
    }

    thead th[aria-sort='ascending'] {
      background-image: $sort-icon-asc;
    }

    thead th[aria-sort='descending'] {
      background-image: $sort-icon-desc;
    }

    tbody tr {
      height: 50px;
      background-color: #fff;
    }

    tbody td {
      height: 50px;
      padding: 0 40px;
      font-size: 15px;
      color: $samtek-black;
      background-color: #fff;
      border: none;
      vertical-align: middle;
    }

    tbody td:first-child {
      font-weight: 700;
    }
  }
}
</style>
